/**
 * Bundle identity embedded into both panel and sender-panel bundles.
 * scripts/deploy/main.sh bundle-parity smoke greps this value
 * in /usr/share/nginx/html/assets/ of both containers — keep a real
 * runtime reference in each entry so tree-shaking cannot drop it.
 */
export const PANEL_BUILD_ID: string = import.meta.env.VITE_PANEL_BUILD_ID ?? '';

export function logPanelBuildId(): void {
	console.info(`[crave] panel build: ${PANEL_BUILD_ID || 'dev'}`);
}
